import {
  GET_ORDERS_ATTEMPT,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_FAILURE,
} from "../../constants";

import { OrdersInitialState } from "../../../types/orders/order";

const initialState: OrdersInitialState = {
  fetchingOrders: 0,
  errorMessage: "",
  success: true,
  orders: [],
  total: 0,
  skip: 0,
  take: 20,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    // getOrders
    case GET_ORDERS_ATTEMPT:
      return {
        ...state,
        fetchingOrders: state.fetchingOrders + 1,
        success: true,
        errorMessage: "",
        skip: action.payload.skip || 0,
        take: action.payload.take || 20,
      };
    case GET_ORDERS_SUCCESS:
      return {
        ...state,
        fetchingOrders: state.fetchingOrders - 1,
        success: true,
        errorMessage: "",
        orders: action.payload.data,
        total: action.payload.total,
      };
    case GET_ORDERS_FAILURE:
      return {
        ...state,
        fetchingOrders: state.fetchingOrders - 1,
        success: false,
        errorMessage: action.payload.error,
      };

    default:
      return state;
  }
};
